import type { FaireProductEntity } from "../../entity_types/product";

export const p_zcgppj8zgp: FaireProductEntity = {
  token: "p_zcgppj8zgp",
  type: "product",
  name: "Neutral Checkered Ceramic Vase",
  brandToken: "b_61cfca11",
  brandName: "Flora Bunda Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/feef4f45f23cc8ea0fccf08e7c34c42b5caebf5ccba182e9137a8625c7858f96.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4890fd375fc9bac677b6512ffecdee95797e1864a732be0cdda36e1d6e3354d7.jpeg",
    "https://cdn.faire.com/fastly/ecd81a1e84b139ceb74871fe29eda48d8c672163598cfa9949f20656234b58b3.jpeg",
  ],
  priceDollars: 20.55,
  description:
    'Bring subtle charm and modern style to your décor with this Neutral Checkered Ceramic Vase. Designed with a soft beige-and-white checkerboard pattern, this cylindrical vase blends effortlessly into contemporary, minimalist, and Scandinavian-inspired spaces. Its clean lines and glossy finish create an elevated yet understated look perfect for year-round decorating.\nStanding 8.5" tall and 4.875" wide, this versatile vase is ideal for fresh florals, dried stems, faux greenery, or as a standalone decorative accent. Place it on an entryway table, bookshelf, coffee table, kitchen counter, or bedside for a touch of modern elegance.\nMade of high-quality ceramic, this vase offers durability and timeless appeal—an easy styling piece for retailers, home stagers, or anyone looking to add a chic neutral accent to their home.',
  tags: [],
  msrpDollars: 82.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:55.614Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
